const menuCatering = [
  {
    id: 1,
    title: "Appetizers & Salads",
    items: [
      {
        id: 1,
        name: "Hummus",
        price: ["Half Tray $46.35", "Full Tray $92.70"],
        description:
          "chick peas blended with tahini sauce, garlic & lemon juice to a creamy perfection",
      },
      {
        id: 2,
        name: "Baba Dip",
        price: ["Half Tray $51.50", "Full Tray $103"],
        description:
          "roasted eggplant blended with tahini sauce, garlic, lemon juice & seasonings",
      },
      {
        id: 3,
        name: "Tabbouli",
        price: ["Half Tray $61.80", "Full Tray $123.60"],
        description:
          "fresh minced parsley, cracked wheat, tomatoes, onions, lemon juice, evoo & seasonings",
      },
      {
        id: 4,
        name: "Fattoush Salad",
        price: ["Half Tray $56.65", "Full Tray $113.30"],
        description:
          "crisp romaine lettuce, tomatoes, cucumbers, purslane(seasonal), parsley, pita chips, evoo & pomegranate infused dressing",
      },
      {
        id: 5,
        name: "Garden Salad",
        price: ["Half Tray $51.50", "Full Tray $103"],
        description:
          "crisp romaine lettuce, tomatoes, cucumbers, tossed in our house dressing",
      },
      {
        id: 6,
        name: "Greek Salad",
        price: ["Half Tray $56.65", "Full Tray $113.30"],
        description:
          "crisp iceberg lettuce, tomatoes, cucumber, green peppers, onions, feta cheese, kalamata olives & greek dressing",
      },
      {
        id: 7,
        name: "Sarma",
        price: ["$2.56 each"],
        description:
          "vegetarian grape leaves stuffed with rice, parsley, tomatoes & seasonings",
      },
      {
        id: 8,
        name: "Falafel",
        price: ["$1.29 each"],
        description:
          "ground chick peas and fava beans, seasoned & fried to a crispy golden brown",
      },
      {
        id: 9,
        name: "Cooked Vegetables",
        price: ["Half Tray $46.35", "Full Tray $92.70"],
        description:
          "grilled mushrooms, onions, green peppers, red peppers, tomatoes topped with olive oil",
      },
    ],
  },
  {
    id: 2,
    title: "Dinners",
    items: [
      {
        id: 1,
        name: "Beef Kebab*",
        price: ["Half Tray $185.40", "Full Tray $370.80"],
        description: "flame broiled marinated angus beef",
      },
      {
        id: 2,
        name: "chicken kebab",
        price: ["Half Tray $133.90", "Full Tray $267.80"],
        description: "flame broiled marinated chicken breast",
      },
      {
        id: 3,
        name: "Lule Kebab*",
        price: [
          "Half Tray(25 pieces) $133.90",
          "Full Tray (1.50 pieces) $267.80",
        ],
        description: "flame broiled marinated ground angus beef",
      },
      {
        id: 4,
        name: "Beef Shawerma*",
        price: ["Half Tray $133.90", "Full Tray $267.80"],
        description:
          "tender marinated angus beef, slow-cooked on a vertical rotisserie",
      },
      {
        id: 5,
        name: "chicken shawerma",
        price: ["Half Tray $133.90", "Full Tray $267.80"],
        description:
          "tender marinated chicken, slow-cooked on a vertical rotisserie",
      },
      {
        id: 6,
        name: "Rice",
        price: ["Half Tray $41.20", "Full Tray $82.40"],
        description: "rice and vermicelli cooked to perfection",
      },
    ],
  },
  {
    id: 3,
    title: "Sides",
    items: [
      {
        id: 1,
        name: "Garlic Sauce",
        price: ["16oz $15.45"],
        description:
          "perfectly mixed vegetable oil, garlic, lemon juice and salt",
      },
      {
        id: 2,
        name: "Tahini Sauce",
        price: ["16oz $15.45"],
        description: "sesame paste blended with garlic, lemon juice and salt",
      },
      {
        id: 3,
        name: "Pickles",
        price: ["16oz $15.45"],
        description: "",
      },
      {
        id: 4,
        name: "Pita Bread",
        price: ["$4.12"],
        description: "",
      },
    ],
  },
  {
    id: 4,
    title: "Desserts",
    items: [
      {
        id: 1,
        name: "Baklava",
        price: ["$2.58 per triangle"],
        description: "",
      },
      {
        id: 2,
        name: "Armenian Rice Pudding",
        price: ["$5.15 each"],
        description: "",
      },
    ],
  },
  {
    id: 5,
    title: "Drinks",
    items: [
      {
        id: 1,
        name: "Pepsi, Diet Pepsi, Orange Crush, Sierra Mist, Mountain Dew, Ginger Ale, Sparkling Water",
        price: ["$2.58"],
        description: "",
      },
      {
        id: 2,
        name: "Yogurt Drink, Mint Yogurt Drink",
        price: ["$3.60"],
        description: "",
      },
      {
        id: 3,
        name: "Orange Juice",
        price: ["$3.09"],
        description: "",
      },
      {
        id: 4,
        name: "Bottle of Water",
        price: ["$2.06"],
        description: "",
      },
    ],
  },
];

export default menuCatering;
